<template>
  <div class="outer-progress-container">
    <div
      id="progress-size-dummy"
      class="progress-container"
      style="visibility: hidden"
    ></div>
    <transition name="fade-in">
      <div v-if="progress > 0">
        <!--<div class="progress-label">{{ progress }}%</div>-->
        <div
          class="progress-container"
          :class="{ 'progress-container-green': progress >= 100 }"
        >
          <div
            class="inner-progress"
            :class="{ 'inner-progress-green': progress >= 100 }"
            :style="progressWidthStyle"
          ></div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import interpolate from 'color-interpolate'

export default {
  name: 'ProgressIndicator',
  props: { progress: Number },
  data() {
    return {
      bgColormap: interpolate(['#003745', '#CDF4DD']),
    }
  },
  computed: {
    progressWidthStyle() {
      return {
        width: `${this.progress >= 100 ? 110 : this.progress + 5}%`,
      }
    },
    backgroundColorStyle() {
      return {
        backgroundColor: this.bgColormap(this.progress / 1000),
      }
    },
    /*progress() {
      return Math.min(
        Math.max(0, Math.floor(this.$store.getters.unlockProgress)),
        100
      )
    },*/
  },
}
</script>

<style scoped>
.outer-progress-container {
  overflow: hidden;
}

.progress-container {
  width: calc(clamp(2rem, 17.6vmin, 4.5rem) * 3.5);
  height: calc(clamp(2rem, 17.6vmin, 4.5rem) * 0.3);
  /*border: solid 2px rgb(34, 138, 138);*/
  border: solid 2px rgba(205, 244, 221, 0.5);
  border-radius: 5px;
  transition: border-color 0.3s;
}

.progress-container-red {
  border-color: rgba(255, 54, 51, 0.5);
}

.progress-container-green {
  border-color: rgba(70, 139, 24, 0.5);
}

.progress-label {
  text-align: center;
  margin-bottom: 2px;
  font-family: 'Montserrat', sans-serif;
  color: rgb(205, 244, 221, 0.5);
}

.inner-progress {
  height: 100%;
  margin-left: -5%;
  /*width: 50%;*/
  /*background-color: rgb(34, 138, 138, 0.25);*/
  background-color: rgba(205, 244, 221, 0.2);
  /*border-radius: 5px;*/
  transition: background-color 0.3;
}

.inner-progress-red {
  background-color: rgba(255, 54, 51, 0.2);
}

.inner-progress-green {
  background-color: rgba(70, 139, 24, 0.2);
}

.fade-in-enter {
  opacity: 0;
}

.fade-in-enter-active {
  transition: opacity 0.3s;
}

.fade-in-leave-to {
  opacity: 0;
}

.fade-in-leave-active {
  transition: opacity 0.3s;
}
</style>
